import React from 'react';
import { Box, Typography } from '@mui/material';

const LoadingState: React.FC = () => {
  return (
    <Box className="user-info-form" style={{ textAlign: 'center', padding: '40px 20px' }}>
      <Typography variant="h6" className="form-title">
        Starting Chat...
      </Typography>
      <Typography variant="body2" className="form-subtitle">
        Please wait while we connect you to support
      </Typography>
      <Box sx={{ mt: 2 }}>
        <div className="loading-spinner" />
      </Box>
    </Box>
  );
};

export default LoadingState;
